(function () {

  var toastTimer;

  function showToast(message) {
    var toast = document.getElementById('wishlist-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'wishlist-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.remove('wishlist-toast--hidden');
    toast.classList.add('wishlist-toast--visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('wishlist-toast--visible');
      toast.classList.add('wishlist-toast--hidden');
    }, 2200);
  }

  function watchContainer(container) {
    // Zooomy's label calls stopPropagation, so use capture phase to fire before it.
    container.addEventListener('click', function () {
      var adding = !container.classList.contains('is-wishlisted');
      container.classList.toggle('is-wishlisted');
      showToast(adding ? 'Product added to wishlist' : 'Product removed from wishlist');
    }, true);
  }

  function init() {
    document.querySelectorAll('.pdp__wishlist, .pc__wishlist').forEach(watchContainer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
